import { createEnv, graphqlPreset, oidcPreset } from '@formic/browser-env';

const env = createEnv('FUSION_OF_', [
  ...graphqlPreset(),
  ...oidcPreset(),
  // Version injected at build/run-time (from Docker build arg BUILD_VERSION)
  { name: 'APP_VERSION', defaultValue: '' },
  // Backend component versions (injected at runtime via container env)
  { name: 'API_VERSION', defaultValue: '' },
  { name: 'IDENTITY_VERSION', defaultValue: '' },
  // Build metadata
  { name: 'SEMVER', defaultValue: '' },
  { name: 'FULLSEMVER', defaultValue: '' },
  { name: 'SHORTSHA', defaultValue: '' },
  { name: 'BUILD_ID', defaultValue: '' },
  { name: 'BUILD_DATE', defaultValue: '' },
  { name: 'SOURCE_BRANCH', defaultValue: '' },
  { name: 'REPO_NAME', defaultValue: '' },
  { name: 'COMPOSITE_TAG', defaultValue: '' },
  { name: 'DEFAULT_THEME', defaultValue: '0' },
  { name: 'STATIC_URI', defaultValue: 'https://localhost:5000' },
  { name: 'IS_ES_ENVIRONMENT', defaultValue: 'false' },
  { name: 'REDIRECTION_PROJECTS', defaultValue: '' },
  { name: 'NO_NAV_PROJECTS', defaultValue: '' },
  { name: 'USER_IDLE_PROJECTS', defaultValue: '' },
  { name: 'NO_NAVBUTTON_PROJECTS', defaultValue: '' },
  { name: 'NAVBUTTON_RECORDS_MEDIA_PROJECTS', defaultValue: '' },
  { name: 'HIDE_ERROR_MESSAGES', defaultValue: 'false' },
  { name: 'HONOR_OF1_URLS', defaultValue: 'false' },
  { name: 'DATE_TIME_PICKER_PROJECTS', defaultValue: '' },
  { name: '24HR_TIME_PICKER_PROJECTS', defaultValue: '' },
  { name: 'SHOW_LEADING_ZEROS', defaultValue: 'false' },
  { name: 'OVERRIDE_PAGE_STYLES', defaultValue: 'false' },
]);

export default env;
